$(document).ready(function() {

    // Banner animation start

    setTimeout(() => {
        if($(".js-banner-media").length > 0){
            $(".js-banner-media").addClass("animated");
        }
        if($(".js-banner-logo").length > 0){
            $(".js-banner-logo").addClass("animated");
        }
        
    }, 0)

    setTimeout(() => {
        if($(".js-banner-media .desktop-video").length > 0){
            document.querySelector(".js-banner-media .desktop-video").autoplay = true;
            document.querySelector(".js-banner-media .desktop-video").play();
        }

        if($(".js-banner-media .mobile-video").length > 0){
            document.querySelector(".js-banner-media .mobile-video").autoplay = true;
            document.querySelector(".js-banner-media .mobile-video").play();
        }
        
    }, 1000);

    // Banner animation end


    // Image Slider Start

    if($(".js-image-carrousel-container").length > 0) {
        var $swiperSelector = $('.js-image-carrousel-container');

        $swiperSelector.each(function(index) {
            var $this = $(this);
            $this.addClass('swiper-slider-' + index);
            
            var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
            var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
            var loop = $this.data('loop') ? $this.data('loop') : false;

            var swiper = new Swiper('.swiper-slider-' + index, {
                direction: 'horizontal',
                loop: loop,
                freeMode: freeMode,
                spaceBetween: 0,
                mousewheel: {
                    forceToAxis: true,
                },
                navigation: {
                    nextEl: '.image-carrousel__next',
                    prevEl: '.image-carrousel__prev',
                    disabledClass: 'image-carrousel__button--disabled'
                  },
                breakpoints: {
                    375: {
                        slidesPerView: 1.05
                    },
                    425: {
                        slidesPerView: 1.2
                    },
                    575: {
                        slidesPerView: 1.65
                    },
                    768: {
                      slidesPerView: 2.3
                    },
                    992: {
                      slidesPerView: 3
                    },
                    1200: {
                      slidesPerView: 3.26
                    }
                },
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev'
                // },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                    dragSize: dragSize
                }
            });
        });

        
        // When Slide < slidesPerView then center align slider
        
        if($(".js-image-carrousel-container .swiper-scrollbar").css("display") === "none") {
            if(!$(".js-image-carrousel-container .image-carrousel__wrapper").hasClass("justify-content-center")) {
                $(".js-image-carrousel-container .image-carrousel__wrapper").addClass("justify-content-center");
            }
        }
        else {
            if($(".js-image-carrousel-container .image-carrousel__wrapper").hasClass("justify-content-center")) {
                $(".js-image-carrousel-container .image-carrousel__wrapper").removeClass("justify-content-center");
            }
        }

        $(window).resize(function() {
            if($(".js-image-carrousel-container .swiper-scrollbar").css("display") === "none") {
                if(!$(".js-image-carrousel-container .image-carrousel__wrapper").hasClass("justify-content-center")) {
                    $(".js-image-carrousel-container .image-carrousel__wrapper").addClass("justify-content-center");
                }
            }
            else {
                if($(".js-image-carrousel-container .image-carrousel__wrapper").hasClass("justify-content-center")) {
                    $(".js-image-carrousel-container .image-carrousel__wrapper").removeClass("justify-content-center");
                }
            }
        })
        
    }

    

    // Image Slider End

});

$('body').on('click', '.productclick', function(e) {
    var first_image = $(this).attr('data-images');
    var second_image = $(this).attr('data-second-img');
    var product_url = $(this).attr('data-product-url');
    $(this).closest('.size-variant-selector__heading').find('label').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.ProductItem__Wrapper').find('.ProductItem__Image').eq(0).attr('src', second_image);
    $(this).closest('.ProductItem__Wrapper').find('.ProductItem__Image').eq(1).attr('src', first_image);
    $(this).closest('.ProductItem__Wrapper').find('a').attr('href', product_url);
});
